import React, { useState, useRef, useEffect } from 'react';
import './QuestionsSection.css';

// Inline SVG icons
const chevronIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E";
const checkIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23007A33' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E";

// Display labels mapped to API values
const mealOptions = [
  { label: 'Dinner', value: 'dinner' },
];

function QuestionsSection({ onShowRecipes }) {
  const [mealTime, setMealTime] = useState(mealOptions[0]); // Now stores the full option object
  const [servingSize, setServingSize] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isFormValid = mealTime !== null && servingSize !== '' && 
    parseInt(servingSize) >= 1 && parseInt(servingSize) <= 20;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMealSelect = (option) => {
    setMealTime(option);
    setIsDropdownOpen(false);
  };

  const handleServingSizeChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === '' || /^\d+$/.test(value)) {
      const numValue = parseInt(value);
      if (value === '' || (numValue >= 0 && numValue <= 20)) {
        setServingSize(value);
      }
    }
  };

  const handleShowRecipes = () => {
    if (isFormValid && onShowRecipes) {
      onShowRecipes({
        mealTime: mealTime.value, // Send the API value
        servingSize: parseInt(servingSize)
      });
    }
  };

  return (
    <div className="questions-section">
      <h2 className="questions-title">
        A quick question to personalize your recipe
      </h2>

      <div className="questions-container">
        {/* Meal Time Question (hidden for now) */}
        {false && (
          <div className="question-item">
            <label className="question-label">When is this meal for?</label>
            <div className="dropdown-wrapper" ref={dropdownRef}>
              <button
                className="dropdown-trigger"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                type="button"
              >
                <span className={`dropdown-text ${!mealTime ? 'placeholder' : ''}`}>
                  {mealTime ? mealTime.label : 'Select answer'}
                </span>
                <img
                  src={chevronIcon}
                  alt=""
                  className={`dropdown-chevron ${isDropdownOpen ? 'open' : ''}`}
                />
              </button>

              {isDropdownOpen && (
                <div className="dropdown-menu">
                  {mealOptions.map((option) => (
                    <button
                      key={option.value}
                      className={`dropdown-option ${mealTime?.value === option.value ? 'selected' : ''}`}
                      onClick={() => handleMealSelect(option)}
                      type="button"
                    >
                      <span className="option-text">{option.label}</span>
                      {mealTime?.value === option.value && (
                        <img src={checkIcon} alt="" className="check-icon" />
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {/* Serving Size Question */}
        <div className="question-item">
          <label className="question-label">How many people are you cooking for?</label>
          <div className="input-wrapper">
            <input
              type="text"
              className="serving-input"
              value={servingSize}
              onChange={handleServingSizeChange}
              placeholder="Enter answer"
              inputMode="numeric"
            />
          </div>
          <p className="serving-note">
            Minimum serving size is 1 and maximum size is 20
            <span className="asterisk">*</span>
          </p>
        </div>
      </div>

      <button 
        className={`show-recipes-button ${isFormValid ? 'active' : ''}`}
        onClick={handleShowRecipes}
        disabled={!isFormValid}
      >
        Show recipes
      </button>
    </div>
  );
}

export default QuestionsSection;
